import type { RoutedFormData } from '../../../../types/templates/form-data';

export const buildBannerType = (formData: RoutedFormData, baseType: string): string => {
  const { league } = formData;
  if (typeof league !== 'string' || !league) return baseType;
  return `${baseType}/${league}`;
};
